;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('CreateAccountController', CreateAccountController)
    .directive('accountExist', AccountExistDirective)

  CreateAccountController.$inject = [
    // Angular
    '$uibModalInstance',

    // Resolved
    'action', 'account'

  ]

  function CreateAccountController (
    // Angular
    $uibModalInstance,

    // Resolved
    action, account

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        action: action,
        account: account,

        // Public Method
        accept: accept,
        cancel: cancel

      })
    }

    function accept () {
      $uibModalInstance.close(self.account)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }

  AccountExistDirective.$inject = [
    // Angular
    '$q', '$timeout',
    // Libs
    // Managers
    'VatManager'
    // Services
    // Const
    // Resolved
  ]
  function AccountExistDirective (
    // Angular
    $q, $timeout,
    // Libs
    // Managers
    VatManager
    // Services
    // Const
    // Resolved
  ) {
    return {
      require: 'ngModel',
      scope: {
        accountExist: '@',
        modelId: '='
      },
      link: (scope, element, attrs, ngModel) => {
        const field = scope.accountExist || 'value'
        ngModel.$asyncValidators.accountExist = function (modelValue, viewValue) {
          const query = VatManager.query({
            conditions: {
              ['' + field]: viewValue
            },
            limit: 1,
            select: '_id',
            count: true
          })
          if (scope.modelId) {
            query.opts.conditions._id = {
              $ne: scope.modelId
            }
          }
          return VatManager.get(query).then(({ data }) => {
            if (data > 0) {
              return $q.reject()
            }
            return true
          })
        }
      }
    }
  }
})(window.angular, window._)
